import { getVariantPagePath } from "./helpers"

// OPTION FOR camelCase SUPPORT:
/**
 * Generates the correct upsell page URL for any template file naming (kebab-case or camelCase).
 * Based on search in pagePaths from the actual pipeline config,
 * instead of relying on files naming convention solely.
 * @param {Object} options
 * @param {string} options.upsellOfferType - API type (UPPERCASE_WITH_UNDERSCORES)
 * @param {string} [options.nameSuffix] - Optional suffix
 */

const generateUpsellPageUrl = ({ upsellOfferType, nameSuffix }) => {
  const PREFIX = "upsell"
  const POSTFIX = "Offer"
  const pagePaths  = pipelineConfig.variants[pipelineConfig.variant].pagePaths || pipelineConfig.pagePaths

  // Turn "PREMIUM_PLAN" to ["premium", "plan"]
  const words = upsellOfferType.toLowerCase().split('_')
  const sortedPagePathsKeys = Object.keys(pagePaths).sort((a, b) => b.length - a.length)

  // Convert words to "PremiumPlan"
  const camelName = words
    .map(w => w.charAt(0).toUpperCase() + w.slice(1))
    .join('');

  const candidateKey = `${PREFIX}${camelName}${nameSuffix || POSTFIX}`

  const keyExists = sortedPagePathsKeys.includes(candidateKey)

  const finalKey = keyExists
    ? candidateKey
    : `${PREFIX}-${words.join('-')}-${nameSuffix || 'offer'}`

  const variantPath = getVariantPagePath({ pagePath: finalKey, pipelineConfig })

  const normalizedVariantPath = variantPath
    ? variantPath.endsWith("/") ? variantPath : `${variantPath}/`
    : ""

  return `${window.location.origin}${pipelineConfig.pathPrefix}${normalizedVariantPath}`
}

const getUpsellOffers = (offers) => {
  return offers
    .filter((offer) => offer.type && offer.type.toLowerCase() !== "basic")
    .sort((a, b) => a.customData.sequence - b.customData.sequence)
}

export {
  generateUpsellPageUrl,
  getUpsellOffers,
}
